import { Component, OnInit, ElementRef } from '@angular/core';
import { ReportService } from '../Services/report.service';
import { AuthService } from '../Services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-report-edit',
  templateUrl: './report-edit.component.html',
  styleUrls: ['../report/report.component.css']
})
export class ReportEditComponent implements OnInit {
  logininfo: Logininfo = this.Auth.loginID;
  user_code: number;
  year: number;
  month: number;
  week: number;

  anchor;

  update_at;
  weeklyReport;

  constructor(
    private _el: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private DBserivice: ReportService,
    public Auth: AuthService,
  ) { }

  ngOnInit() {
    this.user_code = +this.route.snapshot.paramMap.get('user_code');
    if (this.user_code == 0) this.user_code = this.Auth.getUserCode();
    this.year = +this.route.snapshot.paramMap.get('year');
    this.month = +this.route.snapshot.paramMap.get('month');
    this.week = +this.route.snapshot.paramMap.get('week');

    if (this.year == 0) this.year = new Date().getFullYear();
    if (this.month == 0) this.month = new Date().getMonth() + 1;
    if (this.week == 0) this.week = this.getWeekNum();

    this.DBserivice.getWeeklyReport(this.user_code, this.year, this.month, this.week).subscribe(
      res => {
        if (res != null) {
          this.weeklyReport = res;
          //console.log(res);
          this.update_at = this.weeklyReport.updated_at;
        }
      });

    this.anchor = this.DBserivice.anchor;
    this.DBserivice.anchor = "";
    if (this.anchor) {
      const element = this._el.nativeElement.querySelector('#anchor' + this.anchor);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }, 250);
      }
    }
  }

  //TODO項目追加
  addTodo(todo) {
    todo.push(null);
  }

  //TODO項目削除
  deleteTodo(todo, index: number) {
    todo.splice(index, 1);
  }

  //本日の週番号取得
  getWeekNum() {
    let today = new Date();

    if (today.getDay() > 1) {
      today.setDate(today.getDate() - today.getDay() + 1);
    } else if (today.getDay() == 0) {
      today.setDate(today.getDate() - 6);
    }

    let oneday = new Date(this.year, this.month - 1, 1);
    if (oneday > today) {
      if (this.month == 1) {
        this.month = 12;
        this.year -= 1;
      } else {
        this.month -= 1;
      }
      oneday = new Date(this.year, this.month - 1, 1);
    }

    if (oneday.getDay() > 1) {
      oneday.setDate(oneday.getDate() + (8 - oneday.getDay()));
    } else if (oneday.getDay() == 0) {
      oneday.setDate(oneday.getDate() + 1);
    }

    let weeknum = Math.floor((today.getDate() - oneday.getDate()) / 7 + 1);
    return weeknum;
  }

  //週報提出
  update() {
    this.weeklyReport.filing_date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

    //週報のデータを複製
    var report = JSON.parse(JSON.stringify(this.weeklyReport));
    //動態TODOから空白データを削除
    report.this_week_schedule.forEach(item => {
      item.moving = item.moving.filter(v => v);
      //リストが0になった場合項目を１つ追加しておく
      if (item.moving.length == 0) {
        item.moving.push(null);
      }
    });

    //来週の動態から空白削除
    report.next_week_schedule.forEach(item => {
      item.moving = item.moving.filter(v => v);
      if (item.moving.length == 0) {
        item.moving.push(null);
      }
    });

    this.DBserivice.updateWeeklyReport(this.weeklyReport).subscribe(res => {
      this.router.navigate(['/report', this.user_code, this.year, this.month, this.week], { relativeTo: this.route });
    });
  }

  //戻る
  back() {
    if (this.anchor) {
      //詳細へ
      this.router.navigate(['/report', this.user_code, this.year, this.month, this.week], { relativeTo: this.route });
    } else {
      //一覧へ
      this.router.navigate(['/report-list/']);
    }
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }
}

